export default "__VITE_ASSET__CJ7BH1g___"